import React from "react";

type Props = {
  text?: string;
};

const PageLoader = ({ text }: Props) => {
  return (
    <div className="page-loader">
      <div className="loader-content">
        {text || "درحال بارگذاری"}
        <div className="loader-bar"></div>
      </div>
    </div>
  );
};

export default React.memo(PageLoader);
